<template>
  <table class="table table-hover the-datatable" id="datatable">
    <thead>
      <tr v-if="isOrder">
        <th v-if="isPurchase === true">
          <input id="mainCheck" type="checkbox" @click="checkMainCheck()" />
        </th>
        <th>{{ $t('customer.orderDetailTooltip') }}</th>
        <th>{{ $t('mobileDatatable.infoAndDateColumn') }}</th>
      </tr>

      <tr v-if="isStaff">
        <th>{{ $t('mobileDatatable.staffDetailColumn') }}</th>
        <th>{{ $t('mobileDatatable.infoAndStatusColumn') }}</th>
      </tr>

      <tr v-if="isCustomer">
        <th>{{ $t('mobileDatatable.customerDetailColumn') }}</th>
        <th>{{ $t('columns.credit') }}</th>
      </tr>

      <tr v-if="isCustomerCredit">
        <th>{{ $t('mobileDatatable.invoiceDetailColumn') }}</th>
        <th>{{ $t('mobileDatatable.actionAndDateColumn') }}</th>
      </tr>

      <tr v-if="isCoupon">
        <th>{{ $t('mobileDatatable.couponDetailColumn') }}</th>
        <th>{{ $t('mobileDatatable.statusAndDatesColumn') }}</th>
      </tr>

      <tr v-if="isTransactionOrder">
        <th>{{ $t('customer.orderDetailTooltip') }}</th>
        <th>{{ $t('mobileDatatable.customerAndDateColumn') }}</th>
      </tr>

      <tr v-if="isTransactionCredit">
        <th>{{ $t('mobileDatatable.staffAndCustomerColumn') }}</th>
        <th>{{ $t('mobileDatatable.statusAndDateColumn') }}</th>
      </tr>

      <tr v-if="isExchange">
        <th>{{ $t('mobileDatatable.rateDetailColumn') }}</th>
        <th>{{ $t('mobileDatatable.dateAndActionsColumn') }}</th>
      </tr>
    </thead>
    <slot></slot>
  </table>
</template>

<script>
export default {
  props: [
    'isPurchase',
    'checkAll',
    'unCheckAll',
    'isStaff',
    'isCustomer',
    'isCustomerCredit',
    'isOrder',
    'isCoupon',
    'isTransactionOrder',
    'isTransactionCredit',
    'isExchange'
  ],
  methods: {
    checkMainCheck() {
      if ($('#mainCheck').is(':checked')) {
        this.checkAll()
      } else {
        this.unCheckAll()
      }
    }
  }
}
</script>

<style scoped>
th {
  font-weight: bold;
  color: #273246;
}

.fa-sort {
  color: #bbb;
  pointer-events: none;
}
.fa-sort-down,
.fa-sort-up {
  color: blue;
  pointer-events: none;
}

.editable-container {
  position: absolute;
  top: 100px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileDatatable.vue